import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';

const NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY = 'jira.nin.global.scope.enrolment';
const GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY =
	'jira.user.nin.global.scope.enrolment.flag.disabled';

const ninGlobalScopeEnrolmentLocalStorage = createLocalStorageProvider('nin-changeboarding');

export const removeIsGlobalScopeEnrolmentEnabledFromLocalStorage = () =>
	ninGlobalScopeEnrolmentLocalStorage.remove(NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);

export const getIsGlobalScopeEnrolmentEnabledFromLocalStorage = () =>
	ninGlobalScopeEnrolmentLocalStorage.get(NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);

export const getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage = () =>
	ninGlobalScopeEnrolmentLocalStorage.get(
		GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY,
	);

export const setIsGlobalScopeEnrolmentEnabledInLocalStorage = (isNINEnrolmentEnabled: boolean) => {
	// In practice this is very unlikely to fail, as our local storage library checks that local storage is working
	// during initialisation. However in order to be robust we will catch any errors and recover by simply deleting the
	// existing local storage value (it's just a cache, so deleting it and delegating to the server will work fine)
	try {
		ninGlobalScopeEnrolmentLocalStorage.set(
			NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY,
			isNINEnrolmentEnabled,
		);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (e: any) {
		log.safeWarnWithoutCustomerData(
			'nin.global.scope.enrolment',
			'Failed to set local storage value, removing instead',
		);
		removeIsGlobalScopeEnrolmentEnabledFromLocalStorage();
	}
};

export const setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage = () => {
	try {
		ninGlobalScopeEnrolmentLocalStorage.set(
			GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY,
			false,
		);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (e: any) {
		log.safeWarnWithoutCustomerData(
			'nin.global.scope.enrolment',
			'Failed to set local storage flag value',
		);
	}
};
